<template>
    <lay-row space="10">
      <lay-col md="24">
        <lay-panel>
          <lay-form :model="search" style="text-align: start" size="sm">
            <lay-form-item label="代理账号" prop="username" mode="inline"   v-if="allAgentNameArr.length!=0">
              <lay-select v-model="search.key" :show-search="true" :multiple="false">
                <lay-select-option  v-for="agent in allAgentNameArr" :key="agent.userId" :value="agent.userId" :label="agent.userName"></lay-select-option>
                 
              </lay-select>
            </lay-form-item>

            <lay-form-item label="搜索" prop="searchKey" mode="inline" >
              <lay-input placeholder="请输入ip/入口/访问/参数"  v-model="search.searchKey"></lay-input>
            </lay-form-item>


              <lay-form-item label="状态" prop="status" mode="inline">
            <lay-select v-model="search.status" :show-search="true" :multiple="false">
              <lay-select-option :value="0" label="全部" />
               <lay-select-option :value="7" label="正常" />
              <lay-select-option :value="1" label="指纹重复" />
              <lay-select-option :value="2" label="IP重复" />
              <lay-select-option :value="3" label="请求头部重复" />
              <lay-select-option :value="4" label="设备重复" />
              <lay-select-option :value="5" label="老用户" />
              <lay-select-option :value="6" label="来源异常" />
            </lay-select>
          </lay-form-item>

              <lay-form-item label="日期范围"  mode="inline">
              <lay-date-picker  v-model="search.rangeTime" range type="datetime" :placeholder="['开始日期','结束日期']"></lay-date-picker>
            </lay-form-item>


            <lay-form-item   >
              <lay-button type="primary" size="sm" @click="searchUser">查询</lay-button>
            </lay-form-item> 
          </lay-form> 

          <lay-table :page="page" :height="'100%'" :columns="columns" :loading="loading" :data-source="dataSource"
            v-model:selected-keys="selectedKeys" @change="change" @sortChange="sortChange" size="sm">  
             
            <template #type="{ row }">
               <space>
               推广方式：
               <space v-if="row.type==1">
                  代理推广
               </space>
               <space v-else-if="row.type==2">
                 用户分享
               </space>
               <space v-else>
                   自来用户
               </space> 
               </space>

               <div >
                  IP：{{ row.ip }}
               </div> 
            <div >
            <space>
            状态：
             <space v-if="row.state==0">
                正常
               </space>
               <space v-else-if="row.state==1">
                指纹重复
               </space>
               <space v-else-if="row.state==2">
                ip重复
               </space>
               <space v-else-if="row.state==3">
                请求头部重复
               </space> 

               <space v-else-if="row.state==4">
                设备重复
               </space> 
               <space v-else-if="row.state==5">
                老用户
               </space> 
               <space v-else-if="row.state==6">
                来源异常
               </space> 
            </space>
            </div> 
             <space>
              logo状态：
                 <space v-if="row.logoType==0">
                 无访问
               </space>
               <space v-else-if="row.logoType==1">
                有访问
               </space> 
            

             </space> 
          

            </template> 

<template #entryAccessParameters="{ row }">
  <div>入口：{{ row.referrer }}</div>
  <div>访问：{{ row.referer }}</div>
  <div>参数：{{ row.urlParams }}</div>
</template>

<template #browserInfo="{ row }">

  <div>浏览器指纹：{{ row.visitorId }}</div>
  <div>浏览器：{{ row.browser }}</div>
  <div>分辨率：{{ row.screenResolution }}</div>
  <div>操作系统：{{ row.platformTyep }}</div>
   <div>语言：：{{ row.browserLanguage }}</div>
   <div>时区：{{ row.timeZone }}</div>
    <div>CPU 核心数：{{ row.cpuCores }}</div>
     <div>网关： {{ row.networkInfo }}</div>
      <div>请求头： {{ row.userAgent }}</div>
</template> 
                    
            <template #recordType="{ row }">
               <space v-if="row.recordType==1">
                访问
               </space>
               <space v-else-if="row.recordType==2">
                下载
               </space>
               <space v-else-if="row.recordType==3">
                安装
               </space>
               <space v-else-if="row.recordType==4">
                注册
               </space> 

            </template> 


 

                <template #show="{ row }">
               <space v-if="row.show==0">
                显示
               </space>
                 <space v-else-if="row.show==1">
                隐藏
               </space> 
          
            </template> 
 
            

            
          </lay-table> 
        </lay-panel>
  
      </lay-col>
  
    </lay-row>
 
  </template>
  
  <script lang="ts" setup>
  import { ref, reactive } from 'vue'
  import { layer } from '@layui/layer-vue'
  import { allAdminVisit,allAgentName} from '../../api'
  
 
  const loading = ref(false);
  
  const dataSource = ref([]);
  
  const selectedKeys = ref([]);

  const allAgentNameArr=ref([]);
  
  const page = reactive({ current: 1, limit: 10, total: 0 });
  
  const search = reactive({
    key:"",
    status:0,
    rangeTime:[],
    searchKey:""
  })
  
  const columns = ref([
    // { title: "id", key: "id", align: "left" },
         { title: "是否隐藏", key: "show", align: "center", customSlot: "show",width:60},  
      { title: "代理", key: "userName", align: "center",width:60 }, 
      { title: "推广方式/ip/状态/logo", key: "type", align: "left", customSlot: "type",width:100,ellipsisTooltip: true },  

     { title: "操作类型", key: "recordType", align: "center", customSlot: "recordType" ,width:60 },  
     { title: "入口/访问/参数", key: "referer", align: "left", customSlot: "entryAccessParameters",width:200,ellipsisTooltip: true},  
    { title: "浏览器信息", key: "browser", align: "left",ellipsisTooltip: true , customSlot: "browserInfo",width:400},
    { title: "平台", key: "platform", align: "center" ,width:60},  
    { title: "时间", key: "addTime", align: "center" ,width:60}, 
  ]);
  
  const getAllAdminUser = () => {
    loading.value = true; 
    var data = { "page": page.current, "limit": page.limit, "key": search.key,"state":search.status, "startTime":search.rangeTime[0],"endTime":search.rangeTime[1],"searchKey":search.searchKey};
    allAdminVisit(JSON.stringify(data)).then((res: any) => {
      loading.value = false;
      if (res != "" && res.code == 0) {
        dataSource.value = res.data;
        page.total = res.count;
      } else {
        dataSource.value = [];
        page.total = 0;
      }
    })
  }
  //获取数据
  getAllAdminUser();
  
  const change = (page: any) => {
    getAllAdminUser();
  }
  
  const sortChange = (key: any, sort: any) => {
    layer.msg(`字段${key} - 排序${sort}, 你可以利用 sort-change 实现服务端排序`)
  }
   
  //查询接口
  const searchUser = () => {
    page.current=1;
    getAllAdminUser();
  }
   
  const allAgentNameList=()=>{
   
    allAgentName().then((res: any) => {
    
      if (res != "" && res.code == 0) {
        allAgentNameArr.value = res.data;
      
      } else {
        allAgentNameArr.value=[];
      }
    })

  }
  allAgentNameList();
  </script>
  
  <style scoped>
  </style>